import { render, staticRenderFns } from "./TagsSelectionDropdown.vue?vue&type=template&id=fe1a96a0&scoped=true"
import script from "./TagsSelectionDropdown.vue?vue&type=script&lang=js"
export * from "./TagsSelectionDropdown.vue?vue&type=script&lang=js"
import style0 from "./TagsSelectionDropdown.vue?vue&type=style&index=0&id=fe1a96a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1a96a0",
  null
  
)

export default component.exports